<template>
  <div>
    <b-overlay :show="loading" fixed no-wrap variant="transparent" blur="20px" />
  </div>
</template>

<script>
import { AUTOMATION_SOCKET, CP_DETECT_SOCKET, ERROR_CAPTURE_SOCKET, UNIVERSALAI_SOCKET } from '@/sockets'
export default {
  name: 'AutomationCommon',
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    emitSocketEvent(prefix,event,...args) {
      this.$root.$emit(`${prefix}:${event}`,...args)
    },
  },
  async mounted(){
    try {
      this.loading=true
      try {
        if(!AUTOMATION_SOCKET.connected) AUTOMATION_SOCKET.connect()
        AUTOMATION_SOCKET.off()
        const automation_events = [
          'load-test-start',
          'load-test-success',
          'load-test-fail',
          'load-test-finish',
          'load-test-pause',
          'load-test-un-pause',
          'load-test-stop',
        ]
        for (const event of automation_events) AUTOMATION_SOCKET.on(event,this.emitSocketEvent.bind(this,'automation',event))
        if(!ERROR_CAPTURE_SOCKET.connected) ERROR_CAPTURE_SOCKET.connect()
        ERROR_CAPTURE_SOCKET.off()
        const error_capture_events = [
          'sync-errors',
          'sync-web-socket-errors',
          'cors-allowed-domain-updated',
        ]
        for (const event of error_capture_events) ERROR_CAPTURE_SOCKET.on(event,this.emitSocketEvent.bind(this,'error-capture',event))
        if(!CP_DETECT_SOCKET.connected) CP_DETECT_SOCKET.connect()
        CP_DETECT_SOCKET.off()
        const cp_detect_events = [
          'pincode_added',
          'pincode_updated',
          'pincode_removed',
          'central_point_added',
          'central_point_updated',
          'central_point_removed',
          'central_point_default_change',
        ]
        for (const event of cp_detect_events) CP_DETECT_SOCKET.on(event,this.emitSocketEvent.bind(this,'cp-detect',event))
        if(!UNIVERSALAI_SOCKET.connected) UNIVERSALAI_SOCKET.connect()
        UNIVERSALAI_SOCKET.off()
        const universal_ai_events = []
        for (const event of universal_ai_events) UNIVERSALAI_SOCKET.on(event,this.emitSocketEvent.bind(this,'universal-ai',event))
      } catch (ex) {
        console.log('ex',ex)
      }
    } finally {
      this.loading=false
    }
  },
  beforeDestroy(){
    
  },
}
</script>

<style>

</style>